import { apiClient } from './client';

export interface ApiKeyDto {
  id: number;
  name: string;
  keyPreview: string;
  isActive: boolean;
  createdAt: string;
  lastUsedAt: string | null;
}

export interface ApiKeyCreatedResponse {
  id: number;
  name: string;
  apiKey: string; // Full key - only shown once
  keyPrefix: string;
  isActive: boolean;
  createdAt: string;
}

export interface CreateApiKeyRequest {
  name: string;
  permissions?: string;
}

export const apiKeysApi = {
  getByFirm: async (firmId: number): Promise<ApiKeyDto[]> => {
    const response = await apiClient.get(`/api/firms/${firmId}/api-keys`);
    return response.data;
  },

  create: async (firmId: number, data: CreateApiKeyRequest): Promise<ApiKeyCreatedResponse> => {
    const response = await apiClient.post(`/api/firms/${firmId}/api-keys`, data);
    return response.data;
  },

  update: async (firmId: number, id: number, data: Partial<{ name: string; isActive: boolean }>): Promise<ApiKeyDto> => {
    const response = await apiClient.put(`/api/firms/${firmId}/api-keys/${id}`, data);
    return response.data;
  },

  delete: async (firmId: number, id: number): Promise<void> => {
    await apiClient.delete(`/api/firms/${firmId}/api-keys/${id}`);
  },

  regenerate: async (firmId: number, id: number): Promise<ApiKeyCreatedResponse> => {
    const response = await apiClient.post(`/api/firms/${firmId}/api-keys/${id}/regenerate`);
    return response.data;
  },
};
